// src/components/Presupuesto/Table/ExpandableTableStyles.js

const baseFontSize = '12px'
const basePadding = '0.25rem'
const opaqueBorderTint = percentage =>
  `color-mix(in srgb, rgb(var(--border)) ${percentage}%, rgb(var(--surface)))`

const styles = {
  container: {
    width: '100%',
    overflowX: 'auto', // scroll horizontal
    overflowY: 'auto',
    maxHeight: 500,
    borderRadius: 'var(--radius-card)',
    border: '1px solid rgb(var(--border))',
    backgroundColor: 'rgb(var(--surface))',
    fontSize: baseFontSize
  },
  table: {
    tableLayout: 'fixed',
    width: '100%',
    minWidth: 900,
    borderCollapse: 'separate',
    borderSpacing: 0,
    fontSize: baseFontSize,
    color: 'rgb(var(--text))'
  },
  thead: {
    backgroundColor: '#ffffff',
    color: 'rgb(var(--text))',
    position: 'sticky',
    top: 0,
    zIndex: 20,
    fontSize: baseFontSize
  },
  stickyRow: {
    position: 'sticky',
    top: 40,
    zIndex: 10,
    backgroundColor: opaqueBorderTint(70),
    color: 'rgb(var(--text))',
    fontSize: baseFontSize
  },
  rowLevel1: { backgroundColor: opaqueBorderTint(50), fontSize: baseFontSize },
  rowLevel2: { backgroundColor: 'rgb(var(--surface))', fontSize: baseFontSize },
  firstColumnCell: {
    position: 'sticky',
    left: 0,
    zIndex: 5,
    background: 'inherit',
    border: '1px solid rgb(var(--border))',
    width: 250,
    minWidth: 200,
    fontSize: baseFontSize,
    padding: basePadding,
    textAlign: 'center'
  },
  headerFirstColumnCell: {
    position: 'sticky',
    top: 0,
    left: 0,
    zIndex: 25,
    backgroundColor: '#ffffff',
    color: 'rgb(var(--text))',
    border: '1px solid rgb(var(--border))',
    width: 250,
    minWidth: 200,
    fontSize: baseFontSize,
    padding: basePadding,
    textAlign: 'center'
  },
  headerSecondColumnCell: {
    backgroundColor: '#ffffff',
    border: '1px solid rgb(var(--border))',
    textAlign: 'center',
    width: 200,
    minWidth: 200,
    fontSize: baseFontSize,
    padding: basePadding
  },
  headerCell: {
    backgroundColor: '#ffffff',
    border: '1px solid rgb(var(--border))',
    textAlign: 'center',
    width: 340,
    minWidth: 340,
    fontSize: baseFontSize,
    padding: basePadding
  },
  cell: {
    border: '1px solid rgb(var(--border))',
    overflow: 'hidden',
    textOverflow: 'ellipsis',
    whiteSpace: 'nowrap',
    width: 400,
    minWidth: 400,
    fontSize: baseFontSize,
    padding: basePadding
  },
  inputCell: {
    width: '100%',
    padding: '0.25rem',
    border: '1px solid rgb(var(--primary))',
    borderRadius: 4,
    backgroundColor: 'rgb(var(--surface))',
    fontSize: baseFontSize,
    color: 'rgb(var(--text))'
  },
  inputCellData: {
    width: '100%',
    padding: '0.25rem',
    border: 'none',
    outline: 'none',
    backgroundColor: 'rgb(var(--surface))',
    fontSize: baseFontSize,
    color: 'rgb(var(--text))'
  },
  button: {
    background: 'none',
    border: 'none',
    cursor: 'pointer',
    float: 'right',
    color: 'rgb(var(--text))'
  },
  resultadoRow: {
    backgroundColor: opaqueBorderTint(75),
    color: 'rgb(var(--text))',
    fontSize: baseFontSize,
    textAlign: 'center'
  }
}

export default styles
